export default __webpack_public_path__ + "static/media/menu-tile-culture.1b869f44.png";